import { Rbac as Role } from "./rbac";

export default Role;
